import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d3c48a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controller" }
const _hoisted_2 = { class: "controller_seek_bar" }
const _hoisted_3 = { class: "seek_bar_wrap" }
const _hoisted_4 = { class: "seek_bar" }
const _hoisted_5 = ["onMouseenter"]
const _hoisted_6 = {
  key: 0,
  class: "video_semantic_tooltip",
  "data-test": "video-semantic-seekbar-tooltip"
}
const _hoisted_7 = { class: "controller_buttons" }
const _hoisted_8 = {
  key: 0,
  class: "switch",
  "data-test": "player-controller-live-switch"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "buttons" }

import Slider from '@/components/atoms/Slider'
import IconButton from '@/components/molecules/IconButton'
import SimpleSwitch from '@/components/atoms/SimpleSwitch'
import { formatSecondStr } from '@/js/utils/filters'
import { useBrowserName } from '@/js/utils/util'
import APP from '@/js/const/app'
import i18n from '@/plugins/i18n'
import CameraInfoNav from './components/CameraInfoNav'
import PlayerToolTip from './components/PlayerToolTip'
import {
  CameraDetail,
  ArchiveEventsPeopleCounter,
  ArchiveEvents,
  ArchiveEventsMotionDetect,
  ArchiveEventsEnterAlert,
  UserPermissions,
} from '@/@types/typescript-axios'
import { computed, onMounted, ref, watch, withDefaults } from 'vue'
import { useStore } from 'vuex'

type PropsType = {
  modelValue?: number
  isPaused?: boolean
  currentTime?: number
  duration?: number
  useLive?: boolean
  canLive?: boolean
  useOnlyArchive?: boolean
  cameraDetail?: CameraDetail
  eventData?: EventDataType
  videoSemanticEvents?: VideoSemanticSeekbarEventType[]
  /** リストhover中のシーンindex（0始まり）。未指定時は強調なし */
  highlightedVideoSemanticIndex?: number | null
  useCameraInfo?: boolean
  useOtherNav?: boolean
  useCapture?: boolean
  useFullScreen?: boolean
  fullScreenFlag?: boolean
  isShowVideoSemanticNav?: boolean
  video?: HTMLVideoElement | null
  isVideoLoadError?: boolean
  isMultiVideo?: boolean
  useFullSize?: boolean
  /** Detail画面のみtrue。要約検索のVideoDialogでは動体検知等を出さない */
  useEventMarker?: boolean
  speed: number
  useSpeedNav?: boolean
  isArchiveLoaded?: boolean
  division?: number
  showController?: boolean
}

type CameraInfoNavPositionType = {
  bottom: string
  right: string
}

type EventDataType = {
  event: string
  startDateTime: string
  endDateTime: string
}

type VideoSemanticSeekbarEventType = {
  startSec: number
  endSec: number
  sceneIndex: number
}

type SeekbarPosition = { width: string; left: string }

/**
 * seekbar上の開始/終了秒を style(left/width) に変換
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    modelValue: { default: 0 },
    isPaused: { type: Boolean, default: true },
    currentTime: { default: 0 },
    duration: { default: 60 },
    useLive: { type: Boolean, default: false },
    canLive: { type: Boolean, default: true },
    useOnlyArchive: { type: Boolean, default: false },
    cameraDetail: null,
    eventData: null,
    videoSemanticEvents: { default: () => [] },
    highlightedVideoSemanticIndex: { default: null },
    useCameraInfo: { type: Boolean, default: true },
    useOtherNav: { type: Boolean, default: true },
    useCapture: { type: Boolean, default: true },
    useFullScreen: { type: Boolean, default: false },
    fullScreenFlag: { type: Boolean, default: false },
    isShowVideoSemanticNav: { type: Boolean, default: false },
    video: { default: null },
    isVideoLoadError: { type: Boolean, default: false },
    isMultiVideo: { type: Boolean, default: false },
    useFullSize: { type: Boolean, default: false },
    useEventMarker: { type: Boolean, default: false },
    speed: null,
    useSpeedNav: { type: Boolean, default: false },
    isArchiveLoaded: { type: Boolean, default: false },
    division: null,
    showController: { type: Boolean, default: true }
  },
  emits: ["togglePlayPause", "changeDivision", "capture", "fullScreen", "showLastArchive", "toggleDirectionController", "toggleLightingController", "toggleVideoSemantic", "showArchiveDownloadDialog", "showEnterAlertCsvDownloadDialog", "change", "changeSoundVolume", "changeSpeed", "showController", "update:modelValue", "update:useLive", "update:fullScreenFlag"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'togglePlayPause'): void
  (e: 'changeDivision', value: number): void
  (e: 'capture'): void
  (e: 'fullScreen'): void
  (e: 'showLastArchive'): void
  (e: 'toggleDirectionController', value: boolean): void
  (e: 'toggleLightingController', value: boolean): void
  (e: 'toggleVideoSemantic', value: boolean): void
  (e: 'showArchiveDownloadDialog'): void
  (e: 'showEnterAlertCsvDownloadDialog'): void
  (e: 'showEnterAlertCsvDownloadDialog'): void
  (e: 'change'): void
  (e: 'changeSoundVolume', value: number): void
  (e: 'changeSpeed', value: number): void
  (e: 'showController'): void
  (e: 'update:modelValue', value: number): void
  (e: 'update:useLive', value: boolean): void
  (e: 'update:fullScreenFlag', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, isPaused: boolean, currentTime: number, duration: number, useLive: boolean, canLive: boolean, useOnlyArchive: boolean, cameraDetail?: CameraDetail, eventData?: EventDataType, videoSemanticEvents: VideoSemanticSeekbarEventType[], highlightedVideoSemanticIndex: number | null, useCameraInfo: boolean, useOtherNav: boolean, useCapture: boolean, useFullScreen: boolean, fullScreenFlag: boolean, isShowVideoSemanticNav: boolean, video: HTMLVideoElement | null, isVideoLoadError: boolean, isMultiVideo: boolean, useFullSize: boolean, useEventMarker: boolean, speed: number, useSpeedNav: boolean, isArchiveLoaded: boolean, division?: number, showController: boolean };

const store = useStore()





const formatSecondString = formatSecondStr
const soundVolume = ref<number>(0)
const isShowCamaraInfoNav = ref<boolean>(false)
const showOtherNav = ref<boolean>(false)
const hoveredVideoSemanticSceneIndex = ref<number | null>(null)

onMounted(() => {
  init()
})

const langInfo = computed(() => store.getters['app/langInfo'])
const permissions = computed<UserPermissions>(() => store.getters['auth/permissions'])
const selectedArchiveEvents = computed<ArchiveEvents>(
  () => store.getters['detail/selectedArchiveEvents']
)
const useFullSizeVideo = computed(() => store.getters['detail/useFullSizeVideo'])
const cameraInfo = computed(() => store.getters['detail/cameraInfo'])

const displayLive = computed<boolean>(() => props.canLive && props.useLive)
const displayVideoController = computed<boolean>(() => !props.isVideoLoadError)
const useVideoSemantic = computed<boolean>(
  () => !!props.cameraDetail?.use_video_semantic_search && !props.isMultiVideo
)

const selectedValue = computed({
  get: () => props.modelValue,
  set: (newVal: number) => {
    emit('update:modelValue', newVal)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change')
  },
})

const liveState = computed({
  get: () => props.useLive,
  set: (v: boolean) => {
    emit('update:useLive', v)
  },
})

const syncFullScreenFlag = computed({
  get: () => props.fullScreenFlag,
  set: (v: boolean) => {
    emit('update:fullScreenFlag', v)
  },
})

const soundIcon = computed<string>(() => {
  return soundVolume.value > 0 ? 'volume_up' : 'volume_off'
})
/**
 * フルスクリーン切り替え用ボタンのアイコンを切り替え
 */
const fullscreenIcon = computed<string>(() => {
  return syncFullScreenFlag.value ? 'fullscreen_exit' : 'fullscreen'
})
/**
 * その他ボタンの活性、非活性化
 */
const enabledMoreBtn = computed(() => {
  // マルチ映像は分割機能があるので非活性にしない
  // 過去映像は速度変更があるので非活性にしない
  if (props.isMultiVideo || !liveState.value) {
    return true
  } else {
    // 映像詳細のライブ映像はカメラ操作、過去映像ダウンロード、侵入検知が利用できない場合非活性
    return (
      permissions.value.batchDownload || permissions.value.ptz || permissions.value.configEnterAlert
    )
  }
})
/**
 * IEの場合非活性化
 */
const checkIE = computed<boolean>(() => {
  return useBrowserName() !== 'IE'
})
/**
 * fullScreenボタンの活性、非活性化
 * multivideoの場合だけloading中高さが80%になるので
 */
const disabledFullScreenButton = computed<boolean>(() => {
  return props.isMultiVideo ? !props.isArchiveLoaded : false
})

const fullScreenToolTipText = computed<string>(() => {
  return props.fullScreenFlag
    ? i18n.global.t('player_controller.end_of_the_full_screen')
    : i18n.global.t('player_controller.full_screen_display')
})

const fullSizeToolTipText = computed<string>(() => {
  return useFullSizeVideo.value
    ? i18n.global.t('player_controller.end_of_the_full_screen')
    : i18n.global.t('player_controller.full_screen_display')
})
/**
 * カメラ操作の可否
 */
const showToolTipController = computed<boolean>(() => {
  // ライブ映像且つ、利用権限あり且つ、pan、tilt、presetのいずれかが操作可能な場合
  return !props.isMultiVideo && props.cameraDetail !== undefined && props.cameraDetail.use_ptz
})
/**
 * 一括ダウンロードの可否
 */
const showArchiveDownloadNav = computed<boolean>(() => {
  return !props.isMultiVideo
})
/**
 * 侵入検知解析結果CSVダウンロードの可否
 * @return {Boolean} 侵入検知の利用
 */
const showEnterAlertCsvDownloadNav = computed<boolean>(() => {
  return (
    !props.isMultiVideo && props.cameraDetail !== undefined && props.cameraDetail.use_enter_alert
  )
})
/**
 * カメラ照明の可否
 */
const showLightingController = computed<boolean>(() => {
  // TODO TLT様の検証が終わるまで非表示
  return store.getters['app/hasExperimentalFeature']('lighting')
})
/**
 * 音量ボタンの表示・非表示
 */
const showSoundNav = computed<boolean>(() => {
  return !props.isMultiVideo && props.cameraDetail && props.cameraDetail.use_audio
    ? !props.useLive || props.cameraDetail.use_streaming
    : false
})
/**
 * ライブ音量のフラグ
 */
const liveSoundState = computed<boolean>(() => {
  return props.useLive && props.cameraDetail !== undefined && props.cameraDetail.use_streaming
})

const cameraInfoNavPosition = computed<CameraInfoNavPositionType>(() => {
  if (props.isMultiVideo) {
    return {
      bottom: '60px',
      right: '120px',
    }
  } else {
    return {
      bottom: '60px',
      right: '200px',
    }
  }
})

const init = () => {
  if (props.video) {
    if (props.cameraDetail !== undefined && props.cameraDetail.use_audio && !props.video.muted) {
      if (!props.useLive || props.cameraDetail.use_streaming) {
        toggleMute()
      }
    }
  }
}

/**
 * controllerのtooltipのwidth
 * @param {String} text tooltipのtext
 * @return {Number} width tooltipのwidth
 */
const tooltipWidth = (text: string): number => {
  let textWidth = 10
  if (langInfo.value === 'ja') {
    textWidth = 21
  }
  return textWidth * text.length
}

const toSeekbarPosition = (startSec: number, endSec: number, minWidthSec = 0): SeekbarPosition => {
  let widthSec = endSec - startSec
  if (widthSec <= 0 && minWidthSec > 0) {
    widthSec = minWidthSec
  }
  return {
    width: 100 * (widthSec / 60) + '%',
    left: 100 * (Math.floor(startSec) / 60) + '%',
  }
}

/**
 * モーション検知開始位置のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const motionPosition = (data: ArchiveEventsMotionDetect): SeekbarPosition => {
  return toSeekbarPosition(data.startSec, data.startSec + 1)
}

/**
 * 人数カウント開始位置のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const peopleCounterPosition = (data: ArchiveEventsPeopleCounter): SeekbarPosition | undefined => {
  if (data.inOut !== 'I') {
    return
  }
  return toSeekbarPosition(data.startSec, data.endSec)
}

/**
 * 侵入検知開始位置のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const enterAlertPosition = (data: ArchiveEventsEnterAlert): SeekbarPosition => {
  // TODO startSecとendSecが同じ場合があるので最小値を設定(ほとんど同じなので▶マークにしたほうがよいか)
  return toSeekbarPosition(data.startSec, data.endSec, 1)
}

/**
 * AI映像要約シーン区間のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const videoSemanticPosition = (data: VideoSemanticSeekbarEventType): SeekbarPosition => {
  // 0秒区間は視認できる最小幅(1秒相当)で描画する
  return toSeekbarPosition(data.startSec, data.endSec, 1)
}

/**
 * 再生中のAI映像要約シーンかどうか
 */
const isVideoSemanticActive = (event: VideoSemanticSeekbarEventType) => {
  const currentSec = props.modelValue
  // end==start の場合も現在位置との重なり判定ができるよう 1秒区間として扱う
  const endSec = event.endSec > event.startSec ? event.endSec : event.startSec + 1
  return currentSec >= event.startSec && currentSec < endSec
}

/**
 * リストhover中のAI映像要約シーンかどうか
 */
const isVideoSemanticHighlighted = (sceneIndex: number) => {
  return (
    props.highlightedVideoSemanticIndex !== null &&
    props.highlightedVideoSemanticIndex !== undefined &&
    props.highlightedVideoSemanticIndex === sceneIndex
  )
}

const eventPosition = computed(() => {
  const startDateTime = new Date(props.eventData.startDateTime).getSeconds()
  const endDateTime = new Date(props.eventData.endDateTime).getSeconds()

  // TODO startSecとendSecが同じ場合があるので最小値を設定(ほとんど同じなので▶マークにしたほうがよいか)
  return toSeekbarPosition(startDateTime, endDateTime, 1)
})

/**
 * 表示時間、モーション検知エリアの表示切り替え用ナビゲーションを表示
 */
const toggleCamaraInfoNav = () => {
  isShowCamaraInfoNav.value = !isShowCamaraInfoNav.value
}

/**
 * AI映像要約パネルの表示切り替え
 */
const toggleVideoSemanticNav = () => {
  if (liveState.value) {
    return
  }
  emit('toggleVideoSemantic', !props.isShowVideoSemanticNav)
}

/**
 * その他のナビゲーションを表示
 */
const toggleOtherNav = () => {
  showOtherNav.value = !showOtherNav.value
}

/**
 * 最大幅表示の切り替え
 */
const toggleFullWidthVideo = () => {
  store.commit('detail/setFullWidthVideoState', !useFullSizeVideo.value)
}

/**
 * ミュートの切り替え
 */
const toggleMute = () => {
  if (soundVolume.value > 0) {
    // ミュートする場合はミュート前の値を残しておく
    store.commit('detail/setSoundVolume', soundVolume.value)
    soundVolume.value = 0
  } else {
    // ミュートクリア時はstoreの情報をセットする
    soundVolume.value = store.getters['detail/soundVolume']
  }
  emit('changeSoundVolume', soundVolume.value)
}

const changeSoundVolume = () => {
  store.commit('detail/setSoundVolume', soundVolume.value)
  emit('changeSoundVolume', soundVolume.value)
}

/**
 * 再生速度切り替え
 */
const changeSpeed = () => {
  let nextIndex =
    APP.PLAY_SPEED_OPTIONS.findIndex(
      (d: { label: number; text: string }) => d.label === props.speed
    ) + 1
  //  Safari、Edgeの場合speedが2より高い場合、映像が再生されない不具合があるので制限を2にする
  if (
    ((useBrowserName() === 'edge' || useBrowserName() === 'safari') && props.speed === 2) ||
    nextIndex === APP.PLAY_SPEED_OPTIONS.length
  ) {
    nextIndex = 0
  }
  emit('changeSpeed', APP.PLAY_SPEED_OPTIONS[nextIndex].label)
  emit('showController')
}

watch(
  () => props.showController,
  (v) => {
    if (!v) {
      showOtherNav.value = false
      isShowCamaraInfoNav.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(IconButton), {
          icon: __props.isPaused ? 'play_arrow' : 'pause',
          "use-border": false,
          "icon-color": "color-white",
          class: "icon-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('togglePlayPause'))),
          onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('togglePlayPause')))
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Slider), {
            modelValue: _unref(selectedValue),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
            max: __props.duration,
            formatTooltip: _unref(formatSecondString)
          }, null, 8, ["modelValue", "max", "formatTooltip"]),
          (__props.useEventMarker)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedArchiveEvents).motionDetect, (data, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "motion",
                    style: _normalizeStyle(motionPosition(data)),
                    key: 'motion-' + index,
                    "data-test": "seekbar-motion-event"
                  }, null, 4))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedArchiveEvents).peopleCounter, (data, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "people_counter",
                    style: _normalizeStyle(peopleCounterPosition(data)),
                    key: 'people_counter-' + index,
                    "data-test": "seekbar-people-counter-event"
                  }, null, 4))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedArchiveEvents).enterAlert, (data, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "enter_alert",
                    style: _normalizeStyle(enterAlertPosition(data)),
                    key: 'enter_alert-' + index,
                    "data-test": "seekbar-enter-alert-event"
                  }, null, 4))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.videoSemanticEvents, (event) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["video_semantic_scene", {
              'video_semantic_scene--active': isVideoSemanticActive(event),
              'video_semantic_scene--highlighted': isVideoSemanticHighlighted(event.sceneIndex),
            }]),
              style: _normalizeStyle(videoSemanticPosition(event)),
              key: 'video_semantic-' + event.sceneIndex,
              "data-test": "video-semantic-seekbar-event",
              onMouseenter: ($event: any) => (hoveredVideoSemanticSceneIndex.value = event.sceneIndex),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hoveredVideoSemanticSceneIndex.value = null))
            }, [
              (hoveredVideoSemanticSceneIndex.value === event.sceneIndex)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(event.sceneIndex + 1), 1))
                : _createCommentVNode("", true)
            ], 46, _hoisted_5))
          }), 128)),
          (__props.eventData && __props.eventData.event)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(__props.eventData.event),
                style: _normalizeStyle(_unref(eventPosition))
              }, null, 6))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, !__props.useLive]
      ]),
      (_unref(showSoundNav))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["sound", { liveSound: _unref(liveSoundState) }])
          }, [
            _createVNode(_unref(IconButton), {
              icon: _unref(soundIcon),
              "use-border": false,
              "icon-color": "color-white",
              class: "icon-button",
              onClick: toggleMute
            }, null, 8, ["icon"]),
            _createVNode(_unref(Slider), {
              modelValue: soundVolume.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((soundVolume).value = $event)),
              max: 1,
              step: 0.1,
              "show-tooltip": false,
              onChange: changeSoundVolume
            }, null, 8, ["modelValue", "step"])
          ], 2))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _unref(displayVideoController)]
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.canLive && _unref(permissions).archive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", {
              class: _normalizeClass({ act: _unref(liveState) })
            }, "LIVE", 2),
            _createVNode(_unref(SimpleSwitch), {
              modelValue: _unref(liveState),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(liveState) ? (liveState).value = $event : null))
            }, null, 8, ["modelValue"])
          ]))
        : (_unref(permissions).archive && !__props.useOnlyArchive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(IconButton), {
                icon: "skip_next",
                "use-border": false,
                "icon-color": "color-white",
                class: "icon-button skip_next",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showLastArchive'))),
                "data-test": "player-controller-skip"
              })
            ]))
          : _createCommentVNode("", true),
      (__props.useSpeedNav && _unref(checkIE))
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "speed_toggle_button",
            onClick: changeSpeed
          }, _toDisplayString(__props.speed) + "x ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        (__props.useCameraInfo)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 0,
              icon: "visibility",
              "use-border": false,
              "icon-color": "color-white",
              "tool-tip-text": _ctx.$t('player_controller.video_information_display'),
              "tool-tip-width": tooltipWidth(_ctx.$t('player_controller.video_information_display')),
              class: "icon-button",
              onClick: toggleCamaraInfoNav
            }, null, 8, ["tool-tip-text", "tool-tip-width"]))
          : _createCommentVNode("", true),
        (_unref(useVideoSemantic))
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 1,
              icon: "summarize",
              "use-border": false,
              disabled: _unref(liveState),
              "icon-color": __props.isShowVideoSemanticNav ? 'color-event13' : 'color-white',
              "tool-tip-text": _ctx.$t('player_controller.video_semantic_display'),
              "tool-tip-width": tooltipWidth(_ctx.$t('player_controller.video_semantic_display')),
              class: "icon-button",
              onClick: toggleVideoSemanticNav
            }, null, 8, ["disabled", "icon-color", "tool-tip-text", "tool-tip-width"]))
          : _createCommentVNode("", true),
        (__props.useCapture)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 2,
              icon: "photo_camera",
              "use-border": false,
              "icon-color": "color-white",
              disabled: !_unref(displayLive),
              "tool-tip-text": _ctx.$t('player_controller.screenshot'),
              "tool-tip-width": tooltipWidth(_ctx.$t('player_controller.screenshot')),
              class: "icon-button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('capture')))
            }, null, 8, ["disabled", "tool-tip-text", "tool-tip-width"]))
          : _createCommentVNode("", true),
        (!__props.fullScreenFlag && __props.useFullSize)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 3,
              icon: "crop_7_5",
              useBorder: false,
              iconColor: _unref(useFullSizeVideo) ? 'color-primary' : 'color-white',
              toolTipText: _unref(fullSizeToolTipText),
              toolTipWidth: tooltipWidth(_unref(fullSizeToolTipText)),
              class: "icon-button",
              onClick: toggleFullWidthVideo
            }, null, 8, ["iconColor", "toolTipText", "toolTipWidth"]))
          : _createCommentVNode("", true),
        (__props.useFullScreen)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 4,
              disabled: _unref(disabledFullScreenButton),
              icon: _unref(fullscreenIcon),
              "use-border": false,
              "tool-tipText": _unref(fullScreenToolTipText),
              "tool-tip-width": tooltipWidth(_unref(fullScreenToolTipText)),
              "icon-color": "color-white",
              class: "icon-button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('fullScreen')))
            }, null, 8, ["disabled", "icon", "tool-tipText", "tool-tip-width"]))
          : _createCommentVNode("", true),
        (__props.useOtherNav)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 5,
              icon: "more_vert",
              "use-border": false,
              disabled: !_unref(enabledMoreBtn),
              "icon-color": "color-white",
              class: "icon-button",
              onClick: toggleOtherNav,
              "data-test": "player-controller-more-btn"
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (isShowCamaraInfoNav.value)
          ? (_openBlock(), _createBlock(_unref(CameraInfoNav), {
              key: 0,
              "camera-info": _unref(cameraInfo),
              position: _unref(cameraInfoNavPosition),
              "is-multi-video": __props.isMultiVideo,
              "live-state": _unref(liveState),
              onMouseleave: toggleCamaraInfoNav
            }, null, 8, ["camera-info", "position", "is-multi-video", "live-state"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (showOtherNav.value)
          ? (_openBlock(), _createBlock(_unref(PlayerToolTip), {
              key: 0,
              "use-controller": _unref(showToolTipController),
              "use-archive-download-nav": _unref(showArchiveDownloadNav),
              "use-enter-alert-csv-download-nav": _unref(showEnterAlertCsvDownloadNav),
              "use-lighting-controller": _unref(showLightingController),
              "live-state": _unref(liveState),
              division: __props.division,
              "is-multi-video": __props.isMultiVideo,
              permissions: _unref(permissions),
              onMouseleave: toggleOtherNav,
              onShowDirectionController: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('toggleDirectionController', true))),
              onShowLightingController: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('toggleLightingController', true))),
              onShowArchiveDownloadDialog: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('showArchiveDownloadDialog'))),
              onShowEnterAlertCsvDownloadDialog: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('showEnterAlertCsvDownloadDialog'))),
              onChangeDivision: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('changeDivision', $event)))
            }, null, 8, ["use-controller", "use-archive-download-nav", "use-enter-alert-csv-download-nav", "use-lighting-controller", "live-state", "division", "is-multi-video", "permissions"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})